const tabs = (props: any) => {
  const {chargeBackHost, officeValue, programName, checkDate} = props
  switch (officeValue) {
    case '1900':
      return [
        {
          label: '정상',
          endpoint: `${chargeBackHost}/api/select?office_code=${officeValue}&check_date=${checkDate}&company=${programName}`,
        },
        {
          label: '확인필요',
          endpoint: `${chargeBackHost}/api/select/check/customer?office_code=${officeValue}&check_date=${checkDate}&company=${programName}`,
        },
        {
          label: '부관',
          endpoint: `${chargeBackHost}/api/subselect?office_code=${officeValue}&check_date=${checkDate}&company=${programName}`,
        },
        {
          label: '제외수용가',
          endpoint: `${chargeBackHost}/api/select/except?office_code=${officeValue}&check_date=${checkDate}&company=${programName}`,
        },
      ]
    default:
      return [
        {
          label: '정상',
          endpoint: `${chargeBackHost}/api/select?office_code=${officeValue}&check_date=${checkDate}&company=${programName}`,
        },
        {
          label: '확인필요',
          endpoint: `${chargeBackHost}/api/select/check/customer?office_code=${officeValue}&check_date=${checkDate}&company=${programName}`,
        },
        {
          label: '제외수용가',
          endpoint: `${chargeBackHost}/api/select/except?office_code=${officeValue}&check_date=${checkDate}&company=${programName}`,
        },
      ]
  }
}

export default tabs
